import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  webUrlListSchema,
  type CreateWebUrlPayload,
  type UpdateWebUrlPayload,
  type WebUrl,
  type WebUrlListParams,
} from '../types/webUrl.types';

export const webUrlQueryKeys = {
  all: () => ['web-urls'] as const,
  list: (params: WebUrlListParams) => [...webUrlQueryKeys.all(), 'list', params] as const,
};

export const webUrlsQueryOptions = (params: WebUrlListParams = {}) =>
  queryOptions({
    queryKey: webUrlQueryKeys.list(params),
    queryFn: async (): Promise<WebUrl[]> => {
      const res = await apiClient.get(API.webUrl.list, { params });
      return webUrlListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function createWebUrl(payload: CreateWebUrlPayload): Promise<void> {
  await apiClient.post(API.webUrl.create, payload);
}

export async function updateWebUrl(id: number, payload: UpdateWebUrlPayload): Promise<void> {
  await apiClient.patch(API.webUrl.update(id), payload);
}

export async function deleteWebUrl(id: number): Promise<void> {
  await apiClient.delete(API.webUrl.delete(id));
}
